exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nheader[data-v-1f865bd7] {\n  font-size: 12pt;\n  position: relative;\n  min-height: 56px;\n  background-color: #455769;\n}\nheader .header-username-link[data-v-1f865bd7] {\n    font-weight: bold;\n    color: rgba(238, 238, 238, 0.9);\n}\n.header-development[data-v-1f865bd7] {\n  background-color: #6387AA !important;\n}\n.header-staging[data-v-1f865bd7] {\n  background-color: #fa9a4b !important;\n}\n.header-production[data-v-1f865bd7] {\n  background-color: #455769 !important;\n}\n.header-ptest[data-v-1f865bd7] {\n  background-color: #780303 !important;\n}\n.heavier-text[data-v-1f865bd7] {\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f865bd7","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/Header.vue
// module id = 663
// module chunks = 1